.page {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;

  width: 100%;
  max-width: 64rem;
  margin-inline: auto;
  box-sizing: border-box;
  padding: 0.5rem 1rem 3rem;
}

.pageHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;

  padding: 1.5rem 1rem 0.5rem;
  text-align: center;
}

.pageTitle {
  margin: 0;
  font-size: clamp(2rem, 3.5vw, 2.75rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  text-align: center;
  color: var(--rep-color-text-primary);
}

.pageIntro {
  margin: 0 auto;
  max-width: 52rem;
  font-size: clamp(1.2rem, 2vw, 1.45rem);
  font-weight: 500;
  line-height: 1.55;
  text-align: center;
  text-wrap: balance;
  color: var(--rep-color-text-secondary);
}

.mediaCard {
  background-color: var(--rep-color-surface);
  border: 1px solid var(--rep-color-border);
  border-radius: var(--rep-radius-card);
  box-shadow: var(--rep-shadow-card);
  padding: 1.75rem 2rem;
  gap: 2.5rem;
  box-sizing: border-box;
}

.mediaCard h3 {
  margin: 0 0 0.5rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--rep-color-text-primary);
}

.mediaCard p {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.65;
  color: var(--rep-color-text-secondary);
}

/* Spaced Repetition card (Hourglass + Why Bother on left; single-column Intervals fitted tightly on right) */
.intervalsCard {
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content;
  gap: 1.25rem;
  align-items: stretch;

  background-color: var(--rep-color-surface);
  border: 1px solid var(--rep-color-border);
  border-radius: var(--rep-radius-card);
  box-shadow: var(--rep-shadow-card);
  padding: 1.75rem 2rem;
  box-sizing: border-box;
}

.hourglassColumn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
}

.hourglassFrame {
  position: relative;
  flex: 1 1 0;
  min-height: 180px;
  width: 100%;
}

.hourglassImage {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: var(--rep-radius-dialog);
}

.whyBother {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  padding: 1.15rem 1.35rem;
  background-color: var(--rep-color-surface-subtle);
  border: 1px solid var(--rep-color-border);
  border-radius: var(--rep-radius-dialog);
  box-sizing: border-box;
}

.whyBotherTitle {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--rep-color-text-primary);
}

.whyBotherText {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.65;
  color: var(--rep-color-text-secondary);
}

.intervalsColumn {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: max-content;
  padding: 0.65rem 0.85rem;
  background-color: var(--rep-color-surface-subtle);
  border: 1px solid var(--rep-color-border);
  border-radius: var(--rep-radius-dialog);
  box-sizing: border-box;
}

.intervalsTitle {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  white-space: nowrap;
  color: var(--rep-color-text-primary);
}

.intervalKey {
  margin: 0;
  padding-left: 1.35rem;
  font-size: 0.82rem;
  line-height: 1.3;
  white-space: nowrap;
}

.intervalList {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  gap: 0.1rem;

  margin: 0;
  padding-left: 1.35rem;
  color: var(--rep-color-text-secondary);
}

.intervalItem {
  font-size: 0.82rem;
  line-height: 1.3;
  white-space: nowrap;
}

.intervalLabel {
  font-weight: 600;
  color: var(--rep-color-text-primary);
}

.intervalGap {
  color: var(--rep-color-text-muted);
}

@media (max-width: 720px) {
  .page {
    gap: 1.25rem;
    padding: 0.5rem 0.75rem 2rem;
  }

  .mediaCard {
    padding: 1.25rem 1rem;
    gap: 1.25rem;
  }

  .intervalsCard {
    grid-template-columns: 1fr;
    gap: 1.25rem;
    padding: 1.25rem 1rem;
  }

  .hourglassFrame {
    position: static;
    flex: none;
    min-height: 0;
    display: flex;
    justify-content: center;
  }

  .hourglassImage {
    position: static;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 240px;
  }

  .intervalsColumn {
    width: 100%;
  }
}
